import styled from '@emotion/styled'
import { IconButton } from '@resiliatech/birdsong'

export const AlertBox = styled.div`
  padding: 16px;
  background-color: #e3f2fd;
  border-radius: 4px;
  margin-bottom: 16px;
`

export const TextBox = styled.div`
  margin-bottom: 16px;
`

export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 8px;
  top: 8px;
`
